// Routes for the app configurations
// import axios from "axios"
// import { oauthConfig } from "../OauthConfig"

// const baseUrl = `${oauthConfig.authority}`

// Languages, themes, etc.
export const appApi = {
    getLocales: async (lang: string) => {
        // make sure the lang is 2 characters lower case
        lang = lang.substring(0, 2).toLowerCase()

        return import(`../locales/${lang}.json`)
    }
    // getLanguage: async (lang: string) => {
    //     const path = `${baseUrl}/languages/${lang}`
    //     return await axios.get(path)
    // }
}